import { render, staticRenderFns } from "./gameSubscribe.vue?vue&type=template&id=768de54c"
import script from "./gameSubscribe.vue?vue&type=script&lang=js"
export * from "./gameSubscribe.vue?vue&type=script&lang=js"
import style0 from "./gameSubscribe.vue?vue&type=style&index=0&id=768de54c&prod&lang=scss"
import style1 from "./gameSubscribe.vue?vue&type=style&index=1&id=768de54c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports